import { IProjectPermissions } from "models/permissions.models";
import { QueryAPIKey } from "utils/constants/api.constants";
import queries from "../../queries";

export const projectPermissionsQueryConfig = {
  projectPermissions: {
    query: queries.projectPermissions.getProjectPermissions,
    queryKey: [QueryAPIKey.GetProjectPermissions],
    errorMessageKey: "getProjectPermissionsFailure",
    queryOptions: {
      select: (data: {
        projectPermissions: IProjectPermissions;
      }): IProjectPermissions => data.projectPermissions ?? {},
    },
  },
};
